module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("gyPRT"))).then(() => parcelRequire('bP2B6'));